(() => {
  const boot = () => {
    if (!document.body || !document.body.classList.contains('is-bundle-builder-page')) return;
    if (window.__arcticMobileBundleModalAssetReady) return;
    window.__arcticMobileBundleModalAssetReady = true;
    document.documentElement.setAttribute('data-arctic-mobile-bundle-modal', 'ready');

    const cleanFlavor = (text) => {
      let label = (text || '').trim().replace(/\s+/g, ' ');
      label = label.replace(/^×\s*/, '');
      label = label.replace(/^PREMIUM\s+/i, '');
      label = label.replace(/^Freeze Dried Ice Cream\s*\*\s*Only 5 Ingredients\s*\*\s*/i, '');
      label = label.replace(/^Freeze Dried\s+/i, '');
      label = label.replace(/^Ice Cream\s*,?\s*/i, '');
      return label || 'Choose bag';
    };

    const currentCount = () => Number.parseInt(document.querySelector('[data-mobile-count], [data-bundle-count]')?.textContent || '0', 10) || 0;
    const targetCount = () => Number.parseInt(document.querySelector('[data-mobile-target], [data-bundle-target]')?.textContent || document.querySelector('[data-bundle-slots]')?.dataset.slotCount || '0', 10) || 0;

    const ensureModal = () => {
      let modal = document.querySelector('.arctic-mobile-box-modal');
      if (modal) return modal;
      modal = document.createElement('div');
      modal.className = 'arctic-mobile-box-modal';
      modal.hidden = true;
      modal.innerHTML = `
        <div class="arctic-mobile-box-modal__panel" role="dialog" aria-modal="true" aria-labelledby="arctic-mobile-box-title">
          <div class="arctic-mobile-box-modal__header">
            <h2 class="arctic-mobile-box-modal__title" id="arctic-mobile-box-title"></h2>
            <button type="button" class="arctic-mobile-box-modal__close" aria-label="Close">×</button>
          </div>
          <div class="arctic-mobile-box-modal__grid"></div>
          <div class="arctic-mobile-box-modal__footer">
            <button type="button" class="arctic-mobile-box-modal__clear">CLEAR ALL</button>
            <button type="button" class="arctic-mobile-box-modal__cta"></button>
          </div>
        </div>`;
      document.body.appendChild(modal);
      modal.addEventListener('click', (event) => {
        if (event.target === modal || event.target.closest('.arctic-mobile-box-modal__close')) closeModal();
      });
      modal.querySelector('.arctic-mobile-box-modal__clear').addEventListener('click', clearBundle);
      modal.querySelector('.arctic-mobile-box-modal__cta').addEventListener('click', closeModal);
      return modal;
    };

    const renderModal = () => {
      const modal = ensureModal();
      const count = currentCount();
      const target = targetCount();
      modal.querySelector('.arctic-mobile-box-modal__title').textContent = `YOUR BOX (${count}/${target})`;
      modal.dataset.bundleTarget = String(target);
      const grid = modal.querySelector('.arctic-mobile-box-modal__grid');
      grid.innerHTML = '';

      const sourceSlots = [...document.querySelectorAll('.bundle-builder__slot')];
      const slots = sourceSlots.length ? sourceSlots : Array.from({ length: target }, () => null);
      slots.slice(0, target).forEach((sourceSlot, index) => {
        const image = sourceSlot?.querySelector('img');
        const remove = sourceSlot?.querySelector('[data-slot-remove]');
        const variantId = sourceSlot?.dataset.variantId || sourceSlot?.getAttribute('data-variant-id') || '';
        const productId = sourceSlot?.dataset.productId || sourceSlot?.getAttribute('data-product-id') || '';
        const labelKey = cleanFlavor(sourceSlot?.querySelector('.bundle-builder__slot-label')?.textContent || '');
        const rawLabel = sourceSlot?.querySelector('.bundle-builder__slot-label')?.textContent || '';
        const filled = !!image;
        const slot = document.createElement('div');
        slot.className = 'arctic-mobile-box-modal__slot';
        slot.innerHTML = `
          ${filled ? `<button type="button" class="arctic-mobile-box-modal__remove" data-modal-remove="${remove?.dataset.slotRemove || index}" data-modal-variant-id="${variantId}" data-modal-product-id="${productId}" data-modal-label="${labelKey.replace(/"/g, '&quot;')}" aria-label="Remove">×</button>` : ''}
          <div class="arctic-mobile-box-modal__box">${filled ? `<img src="${image.getAttribute('src')}" alt="${(image.getAttribute('alt') || '').replace(/"/g, '&quot;')}">` : ''}</div>
          <span class="arctic-mobile-box-modal__label">${filled ? cleanFlavor(rawLabel) : 'Choose bag'}</span>`;
        grid.appendChild(slot);
      });

      const remaining = Math.max(target - count, 0);
      modal.querySelector('.arctic-mobile-box-modal__cta').textContent = remaining > 0 ? `ADD ${remaining} MORE PRODUCTS` : 'BUNDLE COMPLETE';
    };

    const openModal = () => {
      renderModal();
      ensureModal().hidden = false;
      document.documentElement.classList.add('arctic-mobile-box-open');
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      const modal = document.querySelector('.arctic-mobile-box-modal');
      if (modal) modal.hidden = true;
      document.documentElement.classList.remove('arctic-mobile-box-open');
      document.body.style.overflow = '';
    };

    const removeSlot = (slotIndex, trigger) => {
      const variantId = trigger?.dataset.modalVariantId || '';
      const productId = trigger?.dataset.modalProductId || '';
      const label = trigger?.dataset.modalLabel || '';
      const cards = [...document.querySelectorAll('.bundle-builder__card')];
      const matchingCard = cards.find((card) => {
        const addButton = card.querySelector('[data-add-to-bundle]');
        const selectedOption = card.querySelector('.bundle-builder__card-select')?.selectedOptions?.[0];
        const cardVariantId = addButton?.dataset.variantId || selectedOption?.value || '';
        const cardProductId = addButton?.dataset.productId || card.dataset.productId || '';
        const cardLabel = cleanFlavor(card.querySelector('.bundle-builder__card-name')?.textContent || addButton?.dataset.productTitle || '');
        return (variantId && cardVariantId === variantId) ||
          (productId && cardProductId === productId) ||
          (label && cardLabel && (cardLabel === label || cardLabel.includes(label) || label.includes(cardLabel)));
      });
      const decrement = matchingCard?.querySelector('[data-card-qty="-1"]');
      if (decrement) {
        decrement.click();
      } else {
        document.querySelector(`[data-slot-remove="${slotIndex}"]`)?.click();
      }
      window.setTimeout(renderModal, 120);
    };

    const clearBundle = () => {
      [...document.querySelectorAll('[data-slot-remove]')].reverse().forEach((button) => button.click());
      window.setTimeout(renderModal, 120);
    };

    const isMobileBundleButton = (target) => {
      const button = target?.closest?.('button');
      if (!button) return false;
      if (button.matches('[data-mobile-bar-count], .bundle-builder__mobile-bar-count')) return true;
      return /^Bundle\s+\d+\s*\/\s*\d+$/i.test(button.textContent.trim().replace(/\s+/g, ' '));
    };

    document.addEventListener('click', (event) => {
      const modalRemove = event.target.closest?.('[data-modal-remove]');
      if (modalRemove) {
        event.preventDefault();
        event.stopPropagation();
        removeSlot(modalRemove.dataset.modalRemove, modalRemove);
        return;
      }

      if (isMobileBundleButton(event.target)) {
        event.preventDefault();
        event.stopPropagation();
        openModal();
      }
    }, true);

    window.addEventListener('bundle-product', () => window.setTimeout(renderModal, 100));
    window.addEventListener('remove-product', () => window.setTimeout(renderModal, 100));
    window.__arcticOpenMobileBox = openModal;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
